export const coteacherIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.header-controls',
    intro: 'The Manage Co-Teachers page is where you can manage and assign co-teachers to your students.'
  },
  {
    element: '.alert-secondary.message',
    intro: 'This information panel provides directions on how to use the co-teacher functionality.'
  },
  {
    element: '#searchStudents',
    intro: 'Click here to search a specific student name.'
  },
  {
    element: '.student-item:first-child',
    intro: 'Select the box next to the student\'s name to select them for a co-teacher assignment.'
  },
  {
    element: 'button.btn-success:first-of-type',
    intro: 'After you have selected the students you want to assign to a co-teacher, click here to choose the teacher who will receive access.'
  },
  {
    element: 'button.clear-selection-button',
    intro: 'Click here to unselect the selected students.'
  },
  {
    element: '.margin-top-10.margin-bottom-10',
    intro: 'Click here to select a teacher to grant Co-Teacher access for all of your students.'
  }
];
